import { classNames } from "primereact/utils";
import { getItemWebStorage } from "../../../../features/webStorageSaver";
import { getIndorImageSrc } from "../../../../features";

type ObjectsTypesListProps = {
    objectTypes: string[],
    currentObjectType: string,
    setCurrentObjectType: React.Dispatch<React.SetStateAction<string>>
}

export default function ObjectTypesList({ objectTypes, currentObjectType, setCurrentObjectType }: ObjectsTypesListProps) {
    const localObjectTypes = getItemWebStorage("objectTypes")

    function changeCurrentObjectType(objectType: string) {
        setCurrentObjectType(objectType)
    }

    return (
        <div className="object-types-list">
            <div className="list-header">Объекты</div>
            <div className="list-body">
                {objectTypes.map((objectType: string) => {
                    const { caption, imageIndex, name } = localObjectTypes.find((objType: any) => objType.name === objectType);
                    const listItemClassNames = classNames({
                        "list-item": true,
                        "active": name === currentObjectType
                    })
                    return (
                        <div className={listItemClassNames} onClick={() => changeCurrentObjectType(objectType)}>
                            <img src={getIndorImageSrc(imageIndex)}/>
                            <span>{caption}</span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
